import React, { useState } from 'react';
import { randomLookupPin, saveClientPin } from '../pinAdmin';

function ClientPinBlock({ session, customer, onUpdated }) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const isAdmin = session.role === 'admin';
    const pin = customer?.lookupPin || '';

    const generate = async (e) => {
        e.stopPropagation();
        if (!customer?.id || !customer.phone) {
            setError('This client needs a phone number first.');
            return;
        }
        setBusy(true);
        setError('');
        try {
            const code = await saveClientPin({
                tenantId: session.tenantId,
                customerId: customer.id,
                companyName: session.companyName,
                phone: customer.phone,
                pin: randomLookupPin()
            });
            if (onUpdated) onUpdated(customer.id, code);
        } catch (err) {
            setError(err.message || 'Could not generate a new PIN.');
        }
        setBusy(false);
    };

    return (
        <div>
            <strong>PIN code</strong>
            <div className="d-flex align-items-center gap-2 flex-wrap">
                <span className="font-monospace fw-bold" style={{ fontSize: 18, letterSpacing: '0.12em' }}>{pin || '—'}</span>
                {isAdmin && (
                    <button type="button" className="bd-btn bd-btn-warning bd-btn-sm" disabled={busy} onClick={generate}>
                        {busy ? 'Generating...' : (pin ? 'Generate new code' : 'Generate code')}
                    </button>
                )}
            </div>
            {error ? <div className="text-danger small mt-1">{error}</div> : null}
        </div>
    );
}

export default ClientPinBlock;
